function Jobdescriptionmainpage() {
    return (
        <>


            <div className="theme-inner-banner">
                <div className="container">
                    <h2 className="intro-title  fs-2 text-center nav-link-color text-capitalize">Block chain Developer </h2>
                    {/* <p className="text-center text-white pt-25">Exprience : 2-4 Years I Vacancy : 1</p> */}
                    <p className="text-center text-white pt-25">We are looking for a highly capable Block chain Developer to design, implement, and distribute a secure block chain-based network.<br></br>
                    To ensure success as a Block Chain Developer, you should possess extensive knowledge of programming languages used for block chain development and experience in cryptography.
                    </p>
                    {/* <ul class="page-breadcrumb style-none d-flex justify-content-center">
							<li><a href="index-2.html">Home</a></li>
							<li class="current-page">Blog</li>
						</ul> */}
                </div>
                <img src="images/shape/shape_38.svg" alt="" className="shapes shape-one" />
                <img src="images/shape/shape_39.svg" alt="" className="shapes shape-two" />
            </div>


        </>



    )
}

export default Jobdescriptionmainpage;